export function formatIncludeInBackup(raw = {}) {
  const rows = [];

  Object.entries(raw).forEach(([moduleName, moduleData]) => {

    rows.push({
      id: moduleName,
      label: moduleName,
      type: 'module',
      value: moduleData?.included ?? false
    });

    Object.entries(moduleData?.datasets || {}).forEach(([dataset, enabled]) => {
      rows.push({
        id: `${moduleName}-${dataset}`,
        label: dataset,
        parent: moduleName,
        type: 'dataset',
        value: enabled
      });
    });

  });

  return rows;
}
